module.exports = __webpack_public_path__ + "static/img/blog_using-business-analytics-risk-performance-mgmt_featured-img_730x270_small.7af13a05.jpg";